import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Text as y } from "../../node_modules/@zillow/constellation-10/dist/components/text/text.esm.js";
const BlockQuoteCitation = ({
  children
}) => /* @__PURE__ */ jsx(_StyledText, { asChild: true, textStyle: "body-lg-bold", children: /* @__PURE__ */ jsx("cite", { children }) });
var _StyledText = styled(y).withConfig({
  displayName: "BlockQuoteCitation___StyledText",
  componentId: "sc-pw8cs7-0"
})({
  fontStyle: "italic",
  textAlign: "center",
  display: "block",
  color: "inherit"
});
export {
  BlockQuoteCitation as default
};
